export default {
    '2b-diagram8': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Value-Based ERM models balance robustness and practicality',
            'two': 'Connect risk management to decision making',
            'three': 'Tailor the approach to match',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram8/i18n/en.js